import React from 'react';
import styles from './style.module.scss';

interface SurveyQuestionProps {
  question: string;
}

const SurveyQuestion: React.FC<SurveyQuestionProps> = ({ question }) => {

  return (
    <div className={styles['survey-question']}>
      <h2>{question}</h2>
    </div>
  );

};

export default SurveyQuestion;
